import React, { useState } from "react";
import { useEffect } from "react";
//import { Cropper } from "react-cropper";
import Modal from "react-overlays/Modal";
import "cropperjs/dist/cropper.css";
import Resizer from "react-image-file-resizer";

export default function ModalApp(props) {
  // React state to control Modal visibility
  // const [showModal, setShowModal] = useState(false);
  const showModal = props.showModal;
  const handleClose = props.handleCloseModal;
  const file = props.file
  const uploadedDocs = props.uploadedDocs;
  const setUploadedDocs = props.setUploadedDocs;
  const doc_id = props.doc_id;
  // Backdrop JSX code
  const renderBackdrop = (props) => <div className="backdrop" {...props} />;

  // var handleClose = () => setShowModal(false);
  const [image, setImage] = useState(null);
  //const [cropper,setCropper] = useState(null);
  const [preview, setPreview] = useState(null);
  const callbackImgResize = (newFileUri) => { 
	setImage(newFileUri);
	let newimage = dataURLtoFile(newFileUri,file.name);
	// console.log('n',newimage);
	if(uploadedDocs[doc_id]){
		uploadedDocs[doc_id].push(newimage);
		setUploadedDocs({...uploadedDocs,[doc_id]:uploadedDocs[doc_id]});
	}else{
		setUploadedDocs({...uploadedDocs,[doc_id]:[newimage]});
	}
	handleClose(false);
  }

  //const [callbackImg, setCallbackImg] = useState(null);
	const resizeImage = (imageFile) => {
    // console.log(imageFile);
    if(imageFile.type=='image/jpeg'){
     try {
        Resizer.imageFileResizer(
          imageFile,
          800,
          800,
          "JPEG",
          75,
          0,
          callbackImgResize,
		  "base64"
        );
      } catch (err) {
        console.log(err);
      }
    }else{
      try {
        Resizer.imageFileResizer(
          imageFile,
          800,
          800,
          "PNG",
          75,
          0,
          callbackImgResize,
		  "base64"
        );
      } catch (err) {
        console.log(err);
      }
    }
	  return true;
}
//  var handleSuccess = () => {    console.log("success");};
function dataURLtoFile(dataurl, file_name) {
 var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
 bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
 while(n--){
 u8arr[n] = bstr.charCodeAt(n);
 }
return new File([u8arr], file_name, {type:mime});
}
  // useEffect(()=>{
    if(file !== null && file !== undefined){
      const fileReader = new FileReader();
      fileReader.onload = () => {
		setImage(fileReader.result);
      };
      fileReader.readAsDataURL(file);
      // setImage(URL.createObjectURL(file))
    }
    // },[])

    useEffect(()=>{
      //console.log(image)
      setPreview(null);
    },[image])

/*  const handleCrop = () => {
    const canvas = cropper.getCroppedCanvas();
    canvas.toBlob((blob) => {
      console.log(blob);
      setPreview(URL.createObjectURL(blob));
      if(uploadedDocs[doc_id]){
        uploadedDocs[doc_id].push(blob);
        setUploadedDocs({...uploadedDocs,[doc_id]:uploadedDocs[doc_id]})
        // console.log(uploadedDocs[doc_id])
      }else{
          setUploadedDocs({...uploadedDocs,[doc_id]:[blob]});
      }
    });
    handleClose();
  };
*/
const handleCancel = async () => {
  await resizeImage(file);

  // Save the compressed image in local storage only when the "Done" button is clicked
  const localStorageKey = `compressedImageURL_${doc_id}`;
  localStorage.setItem(localStorageKey, image);
};

  useEffect(()=>{
   // console.log(uploadedDocs)
  },[uploadedDocs])

  return (
    <div className="modal-example crop-img">     

      <Modal
        className="modal"
        show={showModal}
        onHide={handleClose}
        renderBackdrop={renderBackdrop}
      >
        <div>
          <div className="modal-header">
            <div className="modal-title">Preview Image</div>
            
              <span className="close-button" onClick={handleClose}>
              × 
              </span>
           
          </div>
     

<div className="modal-desc">
  <div className="row">
    <div className="col-md-6 cropped-img" style={{ maxHeight: '500px', overflowY: 'auto',overflowX:"auto" }}>
      {image && (
        <img src={image} style={{ width: '100%' }} alt="" />
      )}
      <br />
    </div>
    <div className="col-md-6" style={{ textAlign: "center" }}>
      {preview && (
        <img src={preview} width={300} alt="" />
      )}
    </div>
  </div>
</div>



          <div className="modal-footer">
                <button className="btn btn-success" onClick={handleCancel}>Done</button>
          </div>
        </div>
      </Modal>
    </div>
  );
}